"use client";
import {
  accordion_default
} from "./chunk-JVJMGBL6.mjs";
import "./chunk-VBL42L5O.mjs";
import {
  useAccordionItem
} from "./chunk-DYCAEL7L.mjs";
import {
  useAccordion
} from "./chunk-7MNEOERN.mjs";
import {
  accordion_item_base_default
} from "./chunk-LDUMD4XQ.mjs";
export {
  accordion_default as Accordion,
  accordion_item_base_default as AccordionItem,
  useAccordion,
  useAccordionItem
};
